/* @ngInject */
const saleGo = (
  $state,
  routes,
  saleLocal
) => {
  const self = {}

  self.new = () => {
    $state.go(routes.scrapping.sale.new.path)
  }

  self.details = (_id) => {
    saleLocal.saveCurrentId(_id)
    $state.go(routes.scrapping.sale.details.path)
  }

  self.edit = (_sale, _id) => {
    saleLocal.saveCurrentId(_sale || _id)
    $state.go(routes.scrapping.sale.edit.path)
  }

  self.generateBLWagons = (_sale, _id) => {
    saleLocal.saveCurrentId(_sale || _id)
    $state.go(routes.scrapping.sale.generateBLWagons.path)
  }

  self.generateBLEssieux = (_sale, _id) => {
    saleLocal.saveCurrentId(_sale || _id)
    $state.go(routes.scrapping.sale.generateBLEssieux.path)
  }

  return self
}
export default saleGo



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sale/services/go.service.js